<app-slider></app-slider>
<app-recommended-places [locations]="locations"></app-recommended-places>
<app-explore-different-places [Governrates]="governrats"></app-explore-different-places>
<!-- <div class="container">
    <div class="row">
        <app-card class="col-md-4" *ngFor="let location of locations" [location]="location"></app-card>
    </div>
</div> -->

